import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=63f5adfa&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=63f5adfa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5adfa",
  null
  
)

export default component.exports